import styled from "styled-components";

import Colors from "../../shared/colors";

export default styled.div`
  background: linear-gradient(
    180deg,
    #79a395 0%,
    rgba(248, 248, 248, 0.6) 100%
  );
  height: 100vh;
  width: 100%;
  background-size: cover;

  hr {
    border: 1px solid ${Colors.silver};
  }

  .wrapper-auth {
    padding: 40px 75px 20px 75px;
    max-width: 747px;
  }

  .wrapper-register {
    display: flex;
    align-items: center;
    padding: 10px 75px 25px 75px;
    cursor: pointer;
    text-decoration: none;

    div {
      margin-right: 10px;
      color: ${Colors.doveGray};
    }
  }

  .wrapper-register:hover {
    div {
      color: ${Colors.gray};
    }

    svg path {
      fill: ${Colors.gray};
    }
  }

  .wrapper-login {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    min-width: fit-content;
    height: auto;
    background: ${Colors.white};
    opacity: 0.95;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    max-width: 740px;

    .wrapper-title {
      display: flex;
      align-items: center;

      .text {
        color: ${Colors.aquaDeep};
      }

      .separator {
        border: 1px solid ${Colors.blumine};
        background: ${Colors.blumine};
        height: 30px;
        margin: 10px 10px 0px 10px;
      }
    }

    .welcome {
      margin-top: 15px;
      margin-bottom: 55px;
      color: ${Colors.doveGray};
    }

    .resetPasswordInputDiv {
      display: flex;

      div {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }

      .newPassword {
        margin-right: 9px;
      }

      .confirmPassword {
        margin-left: 9px;
      }

      .error-text {
        height: 20px;
      }
    }
  }

  form {
    margin: 10px 0px 20px 0px;
  }

  form > div {
    display: grid;
  }

  form label {
    color: ${Colors.aquaDeep};
  }

  form input {
    margin-top: 10px;
    margin-bottom: 15px;
    background-color: ${Colors.white} !important;
    color: ${Colors.doveGray} !important;
    border: 0;
    border-bottom: 1px solid ${Colors.silver};
    font-size: 18px;
    line-height: 22px;
    height: 30px;
  }
  form input:focus-visible {
    outline: 0;
  }

  form a {
    position: absolute;
    right: 75px;
    color: ${Colors.aquaDeep};
    text-decoration: none;
    margin-top: 10px;
  }

  form a:hover {
    text-decoration: underline;
  }

  .error-txt {
    color: ${Colors.valencia};
    font-size: 16px;
    line-height: 19px;
    font-style: italic;
    font-weight: normal;
  }

  .successMessage {
    padding: 20px;
    text-align: center;
    margin-bottom: 20px;

    p {
      font-size: 18px;
    }
  }

  .disabledText {
    color: ${Colors.gray} !important;
  }

  .required-text-reset {
    color: ${Colors.valencia};
    font-size: 18px;
    line-height: 22px;
    max-width: fit-content;
    font-style: italic;
  }

  .errorMessageResetPassword {
    color: ${Colors.valencia};
    font-size: 14px;
    max-width: fit-content;
    height: 20px;
    line-height: 17px;
  }

  .custom-login-button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 145px;

    .custom-login-arrow {
      margin-left: 15px;
    }
  }
  .training-video {
    margin: 0;
    position: absolute;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    top: 92%;
    padding-left: 20%;
    padding-right: 20%;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;
